import { ModalProps, Typography } from "antd";
import SimpleModal from "components/Molecules/modal/simple-modal";
import React from "react";

export const ModalAlertChangeConformity = (props: ModalProps) => {
  return (
    <SimpleModal
      title="Change Option"
      okText="Change"
      okButtonProps={{ danger: true }}
      {...props}
    >
      <Typography.Text>
        The test lines will be <span>cleared</span> when changing to other
        option. Are you confirm to proceed?
      </Typography.Text>
    </SimpleModal>
  );
};
